export default __webpack_public_path__ + "static/media/collection-cover-2.a7bbb376.png";